import React, { useCallback, useMemo, useState, useEffect, useRef } from 'react';
import { MaterialReactTable } from 'material-react-table';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    Stack,
    Input,
    InputLabel,
    Select,
    TextField,
    ListSubheader,
    Avatar,
    Typography,
} from '@mui/material';

import { deepOrange, deepPurple } from '@mui/material/colors';
import { DataGrid  } from '@mui/x-data-grid';

import { Delete, Edit } from '@mui/icons-material';
// import { data, states } from './makeData';
import {getAllVM, getAllItems, getAllUsers, updateVM, createSlotsItem, getAllSlotsItems, getAllMoneySlots, createMoneySlots} from '../../api/routes'
import { TableRowsLoader } from '../../utils/TableRowsLoader';

const VendingMachine = ({user_id}) => {

    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [validationErrors, setValidationErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [itemData, setItemData] = useState(() => []);
    const [selectedItem, setSelectedItem] = useState({});
    const [slots, setSlots] = useState(0);
    const [selectedVM, setSelectedVM] = useState("");
    const [qty, setQty] = useState({});
    const [slotItems, setSlotItems] = useState({});
    const [moneySlots, setMoneySlots] = useState({ denomination: {}, qty: {} });
    const [selectedMoneyDenomination, setSelectedMoneyDenomination] = useState({});
    const [moneyQty, setMoneyQty] = useState({});
    const [selectedVMHasCoinDispenser, setSelectedVMHasCoinDispenser] = useState(false);
    const [selectedVMSingleItem, setSelectedVMSingleItem] = useState(false);
    const [selectedVMSingleItemCount, setSelectedVMSingleItemCount] = useState(0);
    const [modalMode, setModalMode] = useState('items');
    const [operatorData, setOperatorData] = useState([]);
    const [operatorAssignModalOpen, setOperatorAssignModalOpen] = useState(false);
    const [selectedOperatorVM, setSelectedOperatorVM] = useState(null);
    const [selectedOperator, setSelectedOperator] = useState('');
    // const [admin, setAdmin] = useState('');
    // const [admins, setAdmins] = useState([])

    const getOperatorLabel = (operatorId) => {
        const operator = operatorData.find((item) => item.guid === operatorId);
        if (!operator) {
            return operatorId ? 'Unknown operator' : 'Unassigned';
        }
        return `${operator.first_name || ''} ${operator.last_name || ''}`.trim() || operator.emp_id || operator.email || 'Operator';
    }

    const updateVMResponseData = (data, operators = operatorData) =>{
        data.map((item, index) => {
            data[index]["id"] = item.guid;
            data[index]["status"] = item.status === 10 ? 'Online' : (item.status === 20? "Offline" :(item.status === 0? "New":"Not Working"));
            data[index]["created_at"] = (new Date(item.created_at)).toLocaleString();
            data[index]["updated_at"] = (new Date(item.updated_at)).toLocaleString();
            data[index]["has_coin_dispenser"] = Boolean(item.metadata && item.metadata.has_coin_dispenser);
            data[index]["single_item_vm"] = Boolean(item.metadata && item.metadata.single_item_vm);
            data[index]["single_item_vm_count"] = item.metadata && item.metadata.single_item_vm ? (item.metadata.single_item_vm_count || 1) : 0;
            const operator = operators.find((op) => op.guid === item.operator_assigned_id);
            data[index]["operator_name"] = operator ? `${operator.first_name || ''} ${operator.last_name || ''}`.trim() : '';
            data[index]["operator_emp_id"] = operator ? operator.emp_id : '';
            // const admin_details = users.filter(item => data[index]["admin_assigned_id"] === item.guid)[0];
            // data[index]["admin_name"] = admin_details.first_name+ " "+ admin_details.last_name;
        })
        return data.filter((item) => item.admin_assigned_id === user_id);
    }

    const getRelevantItemSlots = (slot_data, vms) => {
        const admin_vm_ids = vms.map(item => item.guid);
        console.log({ admin_vm_ids });
        const slot_mapping = {
            item_value: {},
            qty: {},
        }
        slot_data.forEach(item => {
            if (admin_vm_ids.includes(item.vending_machine_id_id)) {
                console.log("!!!!!!!!!!!!!!!", item);
                if(!slot_mapping["item_value"][item.vending_machine_id_id]) {
                    slot_mapping["item_value"][item.vending_machine_id_id] = {};
                    slot_mapping["qty"][item.vending_machine_id_id] = {};
                }
                slot_mapping["item_value"][item.vending_machine_id_id][item.slot_id] = item.item_id_id;
                slot_mapping["qty"][item.vending_machine_id_id][item.slot_id] = item.quantity;
            }
        });
        console.log({slot_mapping});
        return slot_mapping;
    }

    const getRelevantMoneySlots = (slot_data, vms) => {
        const admin_vm_ids = vms.map(item => item.guid);
        const slot_mapping = {
            denomination: {},
            qty: {},
        };
        slot_data.forEach((slot) => {
            if (admin_vm_ids.includes(slot.vending_machine_id_id)) {
                if (!slot_mapping.denomination[slot.vending_machine_id_id]) {
                    slot_mapping.denomination[slot.vending_machine_id_id] = {};
                    slot_mapping.qty[slot.vending_machine_id_id] = {};
                }
                slot_mapping.denomination[slot.vending_machine_id_id][slot.slot_id] = slot.denomination;
                slot_mapping.qty[slot.vending_machine_id_id][slot.slot_id] = slot.quantity;
            }
        });
        return slot_mapping;
    }

    const getAdminsFromUsers = (data) =>{
        return data.filter(item => item.is_admin)
    }

    const fetchData = async () => {
        setLoading(true);
        try {
            // const users = await getAllUsers();
            // setAdmins(getAdminsFromUsers(users));
            const [items, users, vms, slot_items, money_slots] = await Promise.all([getAllItems().then((data)=>{
                return data.filter(i => i.metadata.user_id && i.metadata.user_id === user_id)
            }), getAllUsers(), getAllVM(), getAllSlotsItems(), getAllMoneySlots()]);
            const admin_vm_rows = vms.filter((vm) => vm.admin_assigned_id === user_id);
            const admin_operator_ids = new Set(admin_vm_rows.map((vm) => vm.operator_assigned_id).filter(Boolean));
            const operators = users.filter((item) => item.is_operator && admin_operator_ids.has(item.guid));
            setOperatorData(operators);
            console.log({slot_items});
            const admin_vms = updateVMResponseData(vms, operators);
            const admin_item_slots = getRelevantItemSlots(slot_items, admin_vms);
            const admin_money_slots = getRelevantMoneySlots(money_slots, admin_vms);
            setSlotItems(admin_item_slots);
            setMoneySlots(admin_money_slots);
            setItemData(items);
            setTableData(admin_vms);
            setLoading(false);
        } catch (error) {
            console.log("error", error);
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
        console.log("+++++++++++++++",{tableData});
    }, []);

    const setSelectedVmFromRow = (vm) => {
        if (!vm) {
            return;
        }
        setSelectedVM(vm.guid);
        setSelectedVMHasCoinDispenser(Boolean(vm.has_coin_dispenser));
        setSelectedVMSingleItem(Boolean(vm.single_item_vm));
        setSelectedVMSingleItemCount(vm.single_item_vm ? (parseInt(vm.single_item_vm_count || 1, 10)) : 0);
        const slots = vm.number_of_slots;
        console.log({slots});
        setSlots(slots);
        console.log("slotItems", slotItems)
        console.log(">+-----+++++", slotItems["item_value"][vm.guid], slotItems["qty"][vm.guid]);
        setSelectedItem((slotItems["item_value"] && slotItems["item_value"][vm.guid]) || {});
        setQty((slotItems["qty"] && slotItems["qty"][vm.guid]) || {});
        setSelectedMoneyDenomination((moneySlots["denomination"] && moneySlots["denomination"][vm.guid]) || {});
        setMoneyQty((moneySlots["qty"] && moneySlots["qty"][vm.guid]) || {});
    };

    const openModalFor = (vm, mode) => {
        setSelectedVmFromRow(vm);
        setModalMode(mode);
        setCreateModalOpen(true);
        
        // console.log(">>>>>>>>",{ids}, vms_for_dropdown);
        // const selectedRowsData = ids.map((id) => opData.find((row) => row.guid === id));
        
        // const selected_vm_ids = selectedRowsData[0].vm_ids;
        // const selected_vms = []
        
        // vms_for_dropdown.forEach(vm => {
        //     if (selected_vm_ids.includes(vm.guid)) {
        //         selected_vms.push(createData(vm.guid, vm.status, vm.sales_amount, vm.items_dispensed));
        //     }
        // });
        // console.log(">>>>>>>>",{selected_vms});
        // setRows(selected_vms);
    }

    const handleChange = (event) => {
        const obj = event.target;
        console.log("##############", {obj})
        const key = parseInt(obj.name,10)+1;
        console.log("+++", selectedItem)
        setSelectedItem({ ...selectedItem, [key]: obj.value});
    };

    const handleQtyChange = (event, value) => {
        const obj = event.target;
        console.log("+++++", qty)
        setQty({ ...qty, [obj.name]:parseInt(obj.value || 0, 10)});
    }

    const handleClearItemSlot = (slotId) => {
        setSelectedItem({ ...selectedItem, [slotId]: '' });
        setQty({ ...qty, [slotId]: 0 });
    }

    const handleMoneyDenominationChange = (event) => {
        const obj = event.target;
        setSelectedMoneyDenomination({ ...selectedMoneyDenomination, [obj.name]: obj.value === '' ? 0 : parseInt(obj.value, 10) });
    };

    const handleMoneyQtyChange = (event) => {
        const obj = event.target;
        setMoneyQty({ ...moneyQty, [obj.name]: parseInt(obj.value || 0, 10) });
    };

    const openOperatorAssignModal = (vm) => {
        setSelectedOperatorVM(vm);
        setSelectedVM(vm.guid);
        setSelectedOperator(vm.operator_assigned_id || '');
        setOperatorAssignModalOpen(true);
    };

    const closeOperatorAssignModal = () => {
        setOperatorAssignModalOpen(false);
        setSelectedOperatorVM(null);
        setSelectedOperator('');
    };

    const handleAssignOperatorToVm = async () => {
        if (!selectedOperatorVM || !selectedOperator) {
            alert('Select an operator first');
            return;
        }
        await updateVM(selectedOperatorVM.guid, { operator_assigned: selectedOperator });
        closeOperatorAssignModal();
        await fetchData();
    };

    const handleClearOperatorFromVm = async () => {
        if (!selectedOperatorVM) {
            return;
        }
        await updateVM(selectedOperatorVM.guid, { operator_assigned: null });
        closeOperatorAssignModal();
        await fetchData();
    };

    const handleAssignItemsToVm = async () => {
        console.log({ selectedVM, selectedItem, qty });
        if (modalMode === 'items') {
            const selectedItemTypeCount = new Set(Object.values(selectedItem).filter(Boolean)).size;
            if (selectedVMSingleItem && selectedItemTypeCount > selectedVMSingleItemCount) {
                alert(`This VM allows only ${selectedVMSingleItemCount} item type(s)`);
                return;
            }
            const payload = [];
            Object.keys(selectedItem).forEach(key => {
                payload.push({
                    slot_id: key,
                    item_id: selectedItem[key],
                    vending_machine_id: selectedVM,
                    quantity: qty[key],
                })
            });
            console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@", payload);
            await createSlotsItem(payload);
        }

        if (modalMode === 'cash') {
            if (!selectedVMHasCoinDispenser) {
                alert('This VM does not have a cash dispenser enabled');
                return;
            }
            const moneyPayload = [...Array(16).keys()].map((index) => {
                const slotId = index + 1;
                return {
                    slot_id: slotId,
                    denomination: parseInt(selectedMoneyDenomination[slotId] || 0, 10),
                    vending_machine_id: selectedVM,
                    quantity: parseInt(moneyQty[slotId] || 0, 10),
                };
            });
            console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@", moneyPayload);
            await createMoneySlots(moneyPayload);
        }
        setSelectedItem({});
        setQty({})
        setSelectedMoneyDenomination({});
        setMoneyQty({});
        await fetchData();
    };

    const handleDownloadMachineStock = (vm) => {
        const itemAssignments = (slotItems.item_value && slotItems.item_value[vm.guid]) || {};
        const itemQuantities = (slotItems.qty && slotItems.qty[vm.guid]) || {};
        const rows = Object.keys(itemAssignments)
            .sort((left, right) => parseInt(left, 10) - parseInt(right, 10))
            .map((slotId) => {
                const itemId = itemAssignments[slotId];
                const item = itemData.find((entry) => entry.guid === itemId);
                return {
                    slot_id: slotId,
                    item_name: item ? item.item_name : '',
                    code: item ? (item.code || '') : '',
                    expiry_date: item ? (item.expiry_date || '') : '',
                    quantity: itemQuantities[slotId] || 0,
                    price: item ? item.item_price : '',
                };
            });

        const headers = ['Slot', 'Item Name', 'Code', 'Expiry Date', 'Quantity', 'Price'];
        const csvRows = [
            headers.join(','),
            ...rows.map((row) => [
                row.slot_id,
                row.item_name,
                row.code,
                row.expiry_date,
                row.quantity,
                row.price,
            ].map((value) => `"${String(value ?? '').replace(/"/g, '""')}"`).join(',')),
        ];

        const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${vm.name || 'machine'}-stock.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const getCommonEditTextFieldProps = useCallback(
    (cell) => {
        return {
        error: !!validationErrors[cell.id],
        helperText: validationErrors[cell.id],
        onBlur: (event) => {
        },
        };
    },
    [validationErrors],
    );

    const columns = [
        { field: 'id', headerName: 'ID', width: 350 },
        {
            field: 'name',
            headerName: 'VM Name',
            width: 150,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 100,
        },
        {
            field: 'number_of_slots',
            headerName: 'Slots',
            width: 180,
        },
        {
            field: 'has_coin_dispenser',
            headerName: 'Cash Dispenser',
            width: 160,
            valueGetter: (params) => params.row.has_coin_dispenser ? 'Yes' : 'No',
        },
        {
            field: 'single_item_vm',
            headerName: 'Single Item VM',
            width: 160,
            valueGetter: (params) => params.row.single_item_vm ? 'Yes' : 'No',
        },
        {
            field: 'single_item_vm_count',
            headerName: 'Item Types',
            width: 120,
            valueGetter: (params) => params.row.single_item_vm ? params.row.single_item_vm_count : 'Any',
        },
        {
            field: 'operator_assignment',
            headerName: 'Assigned Operator',
            width: 240,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body2" sx={{ minWidth: 95 }}>
                        {params.row.operator_name || 'Unassigned'}
                    </Typography>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={(event) => {
                            event.stopPropagation();
                            openOperatorAssignModal(params.row);
                        }}
                    >
                        {params.row.operator_assigned_id ? 'Change' : 'Assign'}
                    </Button>
                </Stack>
            ),
        },
        {
            field: 'items_action',
            headerName: 'Items',
            width: 120,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    size="small"
                    onClick={(event) => {
                        event.stopPropagation();
                        openModalFor(params.row, 'items');
                    }}
                >
                    ITEMS
                </Button>
            ),
        },
        {
            field: 'cash_action',
            headerName: 'Cash',
            width: 120,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={(event) => {
                        event.stopPropagation();
                        openModalFor(params.row, 'cash');
                    }}
                    disabled={!params.row.has_coin_dispenser}
                >
                    CASH
                </Button>
            ),
        },
        {
            field: 'download_action',
            headerName: 'Download',
            width: 140,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={(event) => {
                        event.stopPropagation();
                        handleDownloadMachineStock(params.row);
                    }}
                >
                    STOCK
                </Button>
            ),
        },
        // {
        //     field: 'online_vm',
        //     headerName: 'Online Vending Machine',
        //     width: 180,
        // },
        // { field: 'status', headerName: 'Status', width: 100, type: 'number' },
        { field: 'sales_amount', headerName: 'Sales Amount', width: 100, },
        { field: 'items_dispensed', headerName: 'Items Dispensed', width: 130 },
    ];
    

    return (
        <>
            {!loading && <div style={{ height: 400, }}>
                        <DataGrid
                            rows={tableData}
                            columns={columns}
                            // initialState={{
                            // pagination: {
                            //     paginationModel: { page: 0, pageSize: 5 },
                            // },
                            // }}
                            pageSizeOptions={[5, 10]}
                            // checkboxSelection
                        />
                </div>
            }
            <Dialog open={operatorAssignModalOpen} onClose={closeOperatorAssignModal} fullWidth maxWidth="xs">
                <DialogTitle>Assign Operator</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            Machine: {selectedOperatorVM ? selectedOperatorVM.name : ''}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Current operator: {selectedOperatorVM ? getOperatorLabel(selectedOperatorVM.operator_assigned_id) : 'Unassigned'}
                        </Typography>
                        <Select
                            fullWidth
                            displayEmpty
                            value={selectedOperator}
                            onChange={(event) => setSelectedOperator(event.target.value)}
                        >
                            <MenuItem value="" disabled>Select operator</MenuItem>
                            {operatorData.map((operator) => (
                                <MenuItem key={operator.guid} value={operator.guid}>
                                    {`${operator.first_name || ''} ${operator.last_name || ''}`.trim() || operator.emp_id || operator.email}
                                </MenuItem>
                            ))}
                        </Select>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeOperatorAssignModal}>Cancel</Button>
                    <Button color="error" onClick={handleClearOperatorFromVm} disabled={!selectedOperatorVM || !selectedOperatorVM.operator_assigned_id}>Clear</Button>
                    <Button variant="contained" onClick={handleAssignOperatorToVm} disabled={!selectedOperator}>Assign</Button>
                </DialogActions>
            </Dialog>
            <AssignItemtoVMModal            
            open={createModalOpen}
            slots = {slots}
            selectedItem = {selectedItem}
            items={itemData}
            onClose={() => setCreateModalOpen(false)}
            onSubmit={handleAssignItemsToVm}
            onHandleChange={handleChange}
            onHandleChangeQty={handleQtyChange}
            onClearSlot={handleClearItemSlot}
            qty={qty}
            hasCoinDispenser={selectedVMHasCoinDispenser}
            selectedMoneyDenomination={selectedMoneyDenomination}
            onMoneyDenominationChange={handleMoneyDenominationChange}
            moneyQty={moneyQty}
            onMoneyQtyChange={handleMoneyQtyChange}
            mode={modalMode}
            isSingleItemVM={selectedVMSingleItem}
            singleItemVMCount={selectedVMSingleItemCount}
            />
        </>
   
    );
};

//example of creating a mui dialog modal for creating new rows
const COIN_OPTIONS = [1, 2, 5, 10, 20];
const CASH_OPTIONS = [10, 20, 50, 100, 200, 500];

export const AssignItemtoVMModal = ({ open, slots, selectedItem, items, onClose, onSubmit, onHandleChange, onHandleChangeQty, onClearSlot, qty, hasCoinDispenser, selectedMoneyDenomination, onMoneyDenominationChange, moneyQty, onMoneyQtyChange, mode, isSingleItemVM, singleItemVMCount }) => {
    const [itemSearch, setItemSearch] = useState('');
    const searchRef = useRef(null);

    const selectedAllowedItemIds = useMemo(() => {
        return Array.from(new Set(Object.values(selectedItem || {}).filter(Boolean)));
    }, [selectedItem]);

    const getItemsForSlot = useCallback((slotId) => {
        const currentItemId = selectedItem ? selectedItem[slotId] : '';
        if (!isSingleItemVM) {
            return items;
        }
        return items.filter((item) => {
            return item.guid === currentItemId
                || selectedAllowedItemIds.includes(item.guid)
                || selectedAllowedItemIds.length < singleItemVMCount;
        });
    }, [isSingleItemVM, items, selectedAllowedItemIds, selectedItem, singleItemVMCount]);

    const getFilteredItemsForSlot = useCallback((slotId) => {
        const slotItems = getItemsForSlot(slotId);
        if (!itemSearch) return slotItems;
        const term = itemSearch.toLowerCase();
        return slotItems.filter((item) => item.item_name.toLowerCase().includes(term));
    }, [getItemsForSlot, itemSearch]);
    // const [values, setValues] = useState(() =>
    // eslint-disable-next-line no-undef
    // [...Array(slots).keys()].reduce((acc, index) => {
    //     acc[index] = "";
    //     return acc;
    // }, {}),
    // );

    const handleSubmit = () => {
    if (mode !== 'cash' && isSingleItemVM && selectedAllowedItemIds.length > singleItemVMCount) {
        alert(`This VM allows only ${singleItemVMCount} item type(s)`);
        return;
    }
    onSubmit();
    onClose();
    };

    return (
    <Dialog open={open}>
        <DialogTitle textAlign="center">
            {mode === 'cash' ? 'Assign Cash / ATM Slots' : 'Assign Items to Slots'}
        </DialogTitle>
        <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
            {mode !== 'cash' && (
                <Stack
                sx={{
                    width: '100%',
                    minWidth: { xs: '300px', sm: '360px', md: '400px' },
                    gap: '1.5rem',
                    my:3,
                }}
                >
                {isSingleItemVM && (
                    <Typography variant="body2" color="text.secondary">
                        Select up to {singleItemVMCount} item type(s) for this VM. Slot dropdowns are limited to the selected item types.
                    </Typography>
                )}
                {[...Array(slots).keys()].map((key) =>
                    <Stack direction="row" spacing={2} key={`item-slot-${key+1}`}>
                        <Avatar sx={{ bgcolor: deepOrange[500] }}>{key+1}</Avatar>

                        <Select 
                            fullWidth
                            id="demo-simple-select-label"
                            value={!selectedItem || Object.keys(selectedItem).length === 0 ? '' : selectedItem[key+1]}
                            label="Item"
                            name={key}
                            onChange={onHandleChange}
                            onOpen={() => {
                                setItemSearch('');
                                if (searchRef.current) {
                                    searchRef.current.focus();
                                }
                            }}
                        >
                            <ListSubheader
                                sx={{
                                    bgcolor: 'background.paper',
                                    lineHeight: 'unset',
                                    py: 1,
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 1,
                                }}
                            >
                                <TextField
                                    inputRef={searchRef}
                                    fullWidth
                                    size="small"
                                    placeholder="Search bar"
                                    value={itemSearch}
                                    onChange={(event) => setItemSearch(event.target.value)}
                                    onKeyDown={(event) => event.stopPropagation()}
                                />
                            </ListSubheader>
                            {getFilteredItemsForSlot(key+1).map((item)=>{
                            return <MenuItem key={`item-option-${key+1}-${item.guid}`} value={item.guid}>{item.item_name}</MenuItem>
                            })}
                        </Select>
                        <Input
                            placeholder="Enter quantity"
                            name={key+1}
                            value={!qty || Object.keys(qty).length === 0 ? 0 : qty[key+1]}
                            onChange={onHandleChangeQty}
                            type="number"
                        />
                        <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() => onClearSlot(key+1)}
                            disabled={!selectedItem || !selectedItem[key+1]}
                        >
                            Clear
                        </Button>

                    </Stack>
                    )
                }
                </Stack>
            )}
            {mode !== 'items' && hasCoinDispenser && (
                <>
                    <Typography variant="h6" sx={{ mt: 2 }}>Cash / ATM Slots</Typography>
                    <Stack
                        sx={{
                            width: '100%',
                            minWidth: { xs: '300px', sm: '360px', md: '400px' },
                            gap: '1.5rem',
                            my:3,
                        }}
                    >
                    {[...Array(16).keys()].map((key) => {
                        const slotId = key + 1;
                        const denominationOptions = slotId <= 8 ? COIN_OPTIONS : CASH_OPTIONS;
                        return (
                            <Stack key={`money-slot-${slotId}`} spacing={1}>
                                {slotId === 1 && (
                                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700 }}>
                                        COINS
                                    </Typography>
                                )}
                                {slotId === 9 && (
                                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700 }}>
                                        NOTES
                                    </Typography>
                                )}
                                <Stack direction="row" spacing={2}>
                                    <Avatar sx={{ bgcolor: slotId <= 8 ? deepOrange[500] : deepPurple[500] }}>
                                        {slotId}
                                    </Avatar>
                                    <Select
                                        fullWidth
                                        value={selectedMoneyDenomination[slotId] || ''}
                                        label="Denomination"
                                        name={slotId}
                                        onChange={onMoneyDenominationChange}
                                    >
                                        <MenuItem value="">None</MenuItem>
                                        {denominationOptions.map((value) => (
                                            <MenuItem key={`denomination-${slotId}-${value}`} value={value}>
                                                {value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <Input
                                        placeholder="Enter quantity"
                                        name={slotId}
                                        value={moneyQty[slotId] || 0}
                                        onChange={onMoneyQtyChange}
                                        type="number"
                                    />
                                </Stack>
                            </Stack>
                        );
                    })}
                    </Stack>
                </>
            )}
        </form>
        </DialogContent>
        <DialogActions sx={{ p: '1.25rem' }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="secondary" onClick={handleSubmit} variant="contained">
            {mode === 'cash' ? 'Assign Cash Slots' : 'Assign Items to Slots'}
        </Button>
        </DialogActions>
    </Dialog>
    );
    };

const validateRequired = (value) => !!value.length;
const validateEmail = (email) =>
!!email.length &&
email
.toLowerCase()
.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
);
// const validateAge = (age) => age >= 18 && age <= 50;

export default VendingMachine;
